import api from '@/utils/api';

/**
 * Verifies if the users token is valid
 * @returns {Promise}
 */
const verifyApi = () => api.get('auth/valid');

export default verifyApi;
